module.exports = __webpack_public_path__ + "a4aa5f03c9e4d1ebe075e403b55417c2.mp4";